import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, NavLink, useParams } from "react-router-dom";
import API  from "../../services";
import "./BannerInfo.scss"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    FaTelegramPlane,
    FaWhatsapp,
    FaEnvelope,
} from "react-icons/fa";
import { IoLogoFacebook, IoLogoTwitter } from "react-icons/io";
import { UserDetails } from "../../models/UserDetails";
import { connect, useDispatch } from "react-redux";
import { RootState } from "../../models/RootState";
import { toast } from "react-toastify";
import { getRefId } from "../../store/authActions";
import { demoUser } from "../../utils/StringUtils";
import DemoDialog from "../DemoDialog";
import { useTranslation } from "../../hooks/useTranslation";
interface BannerInfoProps {
    userDetails: UserDetails; 
}

const BannerInfo: React.FC<BannerInfoProps> = ({userDetails}) => {
    const { t } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const banner = location.state?.banner;
    const [loading, setLoading] = useState<boolean>(false);
    const [bannerData, setBannerData] = useState<any>(null);
    const [isShareModalOpen, setIsShareModalOpen] = useState(false);
    const [mobDialog, setMobDialog] = useState(false);
    const [demoDialog, setDemoDialog] = useState(false);
    const modalRef = useRef<HTMLDivElement>(null);
    const [refUrl, setRefUrl] = useState("");
    const [refMessage, setRefMessage] = useState("");
    const dispatch = useDispatch();


    const getBannerInfo = async () => {
        setLoading(true);

        let response;
        try {
            response = await API.post(`/webapp/get-promotion-content`, {
                promotionId: banner?.promotionId
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
            return;
        }

        if (response.data.status !== "RS_OK") {
            toast.error(response.data.errDescription);
            navigate("/home");
        }

        if (response && response.data?.promoContent) {
            setBannerData(response.data?.promoContent);
            setPromoMessage();
        }
        setLoading(false);
    };



    const shareDetails = {
        title: "BotYaPot",
        text: `${bannerData?.bannerButton?.[0]?.Content || ""}\n\n${bannerData?.bannerButton?.[0]?.URL || ""}`,
    };    


    useEffect(() => {
        getBannerInfo();
    }, []);

    const handleShare = () => {
        setRefUrl(bannerData?.promoLink);
        if (navigator?.share) {
            navigator
                ?.share({
                    title: shareDetails.title,
                    text: `${bannerData?.bannerButton?.[0]?.Content || ""}\n\n${bannerData?.bannerButton?.[0]?.URL || ""}\n\n${bannerData?.promoMessage || ""}`,
                    url: bannerData?.promoLink,
                })
                .then(() => {
                    console.log("Successfully shared");
                })
                .catch((error) => {
                    console.error("Error sharing:", error);
                    // setIsShareModalOpen(true);
                });
        } else {
            setIsShareModalOpen(true);
        }
    };

    function requestUserContact() {
        try {
          window?.Telegram?.WebApp?.ready();
          window?.Telegram?.WebApp?.requestContact((contact) => {
            if (contact) {
              console.log("Contact received:", contact);
              setTimeout(() => {
                dispatch(getRefId() as any);
              }, 500);
            } else {
              console.log("User declined to share contact.");
            }
          });
        } catch (e) {
          console.log("xc", e)
        }
    }

    const handleClick = () => {
        if (bannerData?.promoLink) {
            window?.open(bannerData?.promoLink, "_blank");
        }
    };

    // const stripHtml = (htmlString: string): string => {
    //     const div = document.createElement("div");
    //     div.innerHTML = htmlString;
    //     return div.textContent || div.innerText || "";
    // };   
    
    const isBackOfficeUser = () => {
        const userKey = userDetails?.UserKey || sessionStorage.getItem("userKey");
        if (!userKey) return false;
        
        const parts = userKey.split("-");
        if (parts.length < 2) return false;
        
        // Check if the part after the dash starts with lowercase 'a'
        const afterDash = parts[1];
        return afterDash && /^a/.test(afterDash);
      };

    const handleBannerButtonClick = (btn: any) => {
        if (demoUser()) {
            setDemoDialog(true);
            return;
        }
        const url = btn.URL.startsWith("http") ? btn.URL : `https://${btn.URL}`;
        if (!isBackOfficeUser() && !userDetails?.MobileNumber && !userDetails?.IsContactOptional) {
            setMobDialog(true);
            return;
        }
        const message = `${btn?.Content || ""}\n\n${url}`;
        setRefUrl(url);        
        setRefMessage(message);  
        if (bannerData?.isShare || btn?.isShare) {
            if (navigator?.share) {
                navigator.share({
                    title: "BotYaPot",
                    text: message,
                }).catch(() => {
                    setIsShareModalOpen(true);
                });
            } else {
                setIsShareModalOpen(true);
            }
        } else {
            window.open(url, "_blank");
        }
    };    
    
    const setPromoMessage = () => {
        try {
          const contentElement = document.getElementById("promo-message");
          if (contentElement) {
            contentElement.innerHTML = bannerData?.promoMessage || `<p>${t("promotions.stayTunedExcitingPromotionsAreOnTheWay")}</p>`;
          } else {
            console.error("Element with ID 'promo-message' not found.");
          }
        } catch (err) {
          console.log(err);
        }
    };      
    useEffect(() => {
        if (bannerData) {
          setPromoMessage();
        }
      }, [bannerData]);

    return (
        <>
            <div className="flex flex-col px-6 mt-4 pb-[7rem] py-[4rem] bannerinfo">
                <div className="flex items-center">
                    <div className="bg-inputbox-color flex p-1 mr-[0.5rem] rounded"
                        onClick={() => navigate(-1)}
                    >
                        <ArrowBackIcon
                            className="text-border-color aspect-square w-[18px]"
                            style={{ width: '20px', height: '20px' }}
                        />
                    </div>
                    <div>{t("promotions.goBack")}</div>
                </div>
                <div className="py-3">
                    <img
                        src={banner?.promotionImage}
                        alt="banner"
                        style={{ height: '100%', width: '100%', borderRadius: '1rem' }}
                    />
                </div>
                {bannerData?.bannerButton?.length >= 1 && (
                    <div className="w-full flex justify-center">
                        <button
                        className="p-2.5 mt-2 w-3/5 text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                        onClick={() => handleBannerButtonClick(bannerData.bannerButton[0])}
                        >
                        {bannerData?.bannerButton[0]?.Text || t("promotions.click")}
                        </button>
                    </div>
                    )}
                {/* <div className="w-full flex justify-center">
                    <button
                        className={`p-2.5 mt-2 w-3/5 text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]`}
                        onClick={() => {
                            if (userDetails?.MobileNumber) {
                                bannerData?.isShare ? handleShare() : handleClick();
                            } else {
                                setMobDialog(true); 
                            }
                        }}
                    >
                        REFER NOW!!!!
                    </button>
                </div> */}
                <div
                id="promo-message"
                className="mt-2 rules-content-ctn text-white text-sm leading-relaxed px-2"
                ></div>
                {/* Buttons after content (if more than 1) */}
                {bannerData?.bannerButton?.length > 1 &&
                bannerData.bannerButton.slice(1).map((btn: any, idx: number) => {
                    return (
                    <div className="w-full flex justify-center" key={idx}>
                        <button
                        className="p-2.5 mt-2 w-3/5 text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                        onClick={() => handleBannerButtonClick(btn)}
                        >
                        {btn?.Text || t("promotions.click")}
                        </button>
                    </div>
                    );
                })}
                {/* <div className="w-full flex justify-center">
                    <button
                        className={`p-2.5 mt-2 w-3/5 text-sm text-white whitespace-nowrap bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]`}
                        onClick={() => {
                            if (userDetails?.MobileNumber) {
                                bannerData?.isShare ? handleShare() : handleClick();
                            } else {
                                setMobDialog(true); 
                            }
                        }}
                    >
                        HURRY REFER NOW!!!!
                    </button>
                </div> */}
            </div>

            {mobDialog && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                  <div className="bg-inputbox-color p-6 rounded-lg w-full max-w-md">
                    <h3 className="text-white text-lg mb-4 text-center">
                      {t("promotions.shareYourContact")}
                    </h3>
                    <p className="text-white text-center">
                      {t("promotions.toReferYourFriendsPleaseShareYourMobileNumber")}
                    </p>
                    <div className="mt-4 flex gap-4">
                      <button
                        className="w-1/2 bg-meicnbg-color text-white px-4 py-2 rounded hover:bg-gray-700"
                        onClick={() => setMobDialog(false)}
                      >
                        {t("common.close")}
                      </button>
                      <button
                        onClick={requestUserContact}
                        className="w-1/2 bg-meicnbg-color text-white px-4 py-2 rounded hover:bg-gray-700"
                      >
                        {t("profile.share")}
                      </button>
                    </div>
                  </div>
                </div>
            )}

            <DemoDialog
              isOpen={demoDialog}
              onClose={() => setDemoDialog(false)}
            />

            {isShareModalOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                    <div
                        ref={modalRef}
                        className="bg-inputbox-color p-6 rounded-lg w-full max-w-md"
                    >
                        <h3 className="text-white text-lg mb-4 text-center">
                            {t("promotions.shareOptions")}
                        </h3>
                        <div className="flex justify-around">
                            <button
                                className="p-2 hover:text-blue-500"
                                onClick={() =>
                                    window.open(
                                        `https://twitter.com/intent/tweet?text=${encodeURIComponent(refMessage)}`,
                                        "_blank"
                                    )
                                }
                            >
                                <IoLogoTwitter size={24} color="#1DA1F2" /> {/* Twitter Blue */}
                            </button>
                            <button
                                className="p-2 hover:text-blue-700"
                                onClick={() =>
                                    window.open(
                                        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(refUrl)}`,
                                        "_blank"
                                    )
                                }
                            >
                                <IoLogoFacebook size={24} color="#4267B2" />{" "}
                                {/* Facebook Blue */}
                            </button>
                            <button
                                className="p-2 hover:text-green-500"
                                onClick={() =>
                                    window.open(
                                        `https://wa.me?text=${encodeURIComponent(refMessage)}`,
                                        "_blank"
                                    )
                                }
                            >
                                <FaWhatsapp size={24} color="#25D366" /> {/* WhatsApp Green */}
                            </button>
                            <button
                                className="p-2 hover:text-blue-400"
                                onClick={() =>
                                    window.open(
                                        `https://t.me/share/url?text=${encodeURIComponent(refMessage)}&url=${encodeURIComponent(refUrl)}`,
                                        "_blank"
                                    )
                                }
                            >
                                <FaTelegramPlane size={24} color="#0088cc" />{" "}
                                {/* Telegram Blue */}
                            </button>
                            <button
                                className="p-2 hover:text-gray-300"
                                onClick={() =>
                                    window.open(
                                        `mailto:?subject=${encodeURIComponent("BotYaPot")}&body=${encodeURIComponent(refMessage)}`,
                                        "_blank"
                                    )
                                }
                            >
                                <FaEnvelope size={24} color="#D44638" /> {/* Mail Red */}
                            </button>
                        </div>
                        <button
                            className="mt-4 w-full bg-meicnbg-color text-white px-4 py-2 rounded hover:bg-gray-700"
                            onClick={() => setIsShareModalOpen(false)}
                        >
                            {t("common.close")}
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
      userDetails: state.userDetails?.userDetails,
    };
  };

export default connect(mapStateToProps)(BannerInfo) ;


